<header
  id="main-header"
  [ngClass]="{ scrolled: isScrolled }"
  class="fixed z-50 py-6 px-6 md:px-12 header-glass"
>
  <div class="container mx-auto flex justify-between items-center">
    <a href="#" class="text-2xl font-extrabold text-primary">Estate360Hub</a>

    <nav class="hidden md:flex space-x-8 items-center">
      <a
        routerLink="home"
        routerLinkActive="active"
        href="#"
        class="text-primary hover:text-accent-blue transition-colors duration-200"
        >Home</a
      >

      <a
        routerLink="about"
        routerLinkActive="active"
        href="#"
        class="text-primary hover:text-accent-blue transition-colors duration-200"
        >About Us</a
      >
      <a
        routerLink="contact"
        routerLinkActive="active"
        href="#"
        class="text-primary hover:text-accent-blue transition-colors duration-200"
        >Contact</a
      >
      <button
        (click)="openModal()"
        class="btn-primary px-6 py-2 rounded-full font-medium shadow-lg hover:shadow-xl transition-all duration-300"
      >
        Request a Demo
      </button>
    </nav>

    <div class="lg:hidden">
      <button
        (click)="toggleMobileMenu()"
        class="text-primary focus:outline-none"
      >
        <svg
          class="w-8 h-8"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16"
          ></path>
        </svg>
      </button>
    </div>
  </div>

  <!-- Mobile menu -->
  <div
    id="mobile-menu"
    *ngIf="isMobileMenuOpen"
    class="fixed top-0 right-[250px] h-[500px] w-64 bg-card shadow-lg p-6 z-50 flex flex-col items-start space-y-6 bg-black transition-transform duration-500 transform translate-x-0"
    [ngClass]="{
      'translate-x-full': !isMobileMenuOpen,
      'translate-x-0': isMobileMenuOpen
    }"
  >
    <button (click)="closeMobileMenu()" class="self-end text-primary mb-4">
      <svg
        class="w-8 h-8"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>

    <a
      (click)="closeMobileMenu()"
      routerLink="home"
      routerLinkActive="active"
      href="#"
      class="text-primary text-lg hover:text-accent-blue transition-colors duration-200"
      >Home</a
    >
    <a
      (click)="closeMobileMenu()"
      routerLink="about"
      routerLinkActive="active"
      href="#"
      class="text-primary text-lg hover:text-accent-blue transition-colors duration-200"
      >About Us</a
    >
    <a
      (click)="closeMobileMenu()"
      routerLink="contact"
      routerLinkActive="active"
      href="#"
      class="text-primary text-lg hover:text-accent-blue transition-colors duration-200"
      >Contact</a
    >

    <button
      (click)="openModal()"
      class="btn-primary px-6 py-3 rounded-full font-medium w-full text-lg shadow-lg hover:shadow-xl transition-all duration-300"
    >
      Request a Demo
    </button>

    <div class="hidden ??flex items-center space-x-2 mt-auto">
      <span class="text-primary">Light Mode</span>
      <label
        for="theme-toggle"
        class="relative inline-flex items-center cursor-pointer"
      >
        <input type="checkbox" id="theme-toggle" class="sr-only peer" checked />
        <div
          class="w-11 h-6 bg-gray-200 rounded-full peer-focus:ring-4 peer-focus:ring-blue-300 peer dark:peer-focus:ring-blue-800 dark:bg-gray-700 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600 peer-checked:after:translate-x-full"
        ></div>
      </label>
    </div>
  </div>
  <!-- <div
    id="mobile-menu"
    class="fixed top-0 right-[250px] h-full w-64 bg-card shadow-lg p-6 z-50 flex flex-col items-start space-y-6 bg-black"
  >
    <button id="close-mobile-menu" class="self-end text-primary mb-4">
      <svg
        class="w-8 h-8"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        ></path>
      </svg>
    </button>
    <a
      href="#features"
      class="text-primary text-lg hover:text-accent-blue transition-colors duration-200"
      >Features</a
    >
    <a
      href="#solutions"
      class="text-primary text-lg hover:text-accent-blue transition-colors duration-200"
      >Solutions</a
    >
    <a
      href="#pricing"
      class="text-primary text-lg hover:text-accent-blue transition-colors duration-200"
      >Pricing</a
    >
    <a
      href="#about"
      class="text-primary text-lg hover:text-accent-blue transition-colors duration-200"
      >About Us</a
    >
    <a
      href="#contact"
      class="text-primary text-lg hover:text-accent-blue transition-colors duration-200"
      >Contact</a
    >
    <button
      class="btn-primary px-6 py-3 rounded-full font-medium w-full text-lg shadow-lg hover:shadow-xl transition-all duration-300"
    >
      Request a Demo
    </button>
    <div class="flex items-center space-x-2 mt-auto">
      <span class="text-primary">Light Mode</span>
      <label
        for="theme-toggle"
        class="relative inline-flex items-center cursor-pointer"
      >
        <input type="checkbox" id="theme-toggle" class="sr-only peer" checked />
        <div
          class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"
        ></div>
      </label>
    </div>
  </div> -->
</header>

<!-- Modal -->
<div
  *ngIf="showModal"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
>
  <div
    class="bg-white w-full max-w-lg rounded-lg shadow-lg p-6 relative max-sm:mx-4"
  >
    <h2 *ngIf="!isSuccess" class="text-xl font-bold mb-4 text-[#111]">
      Register Estate
    </h2>
    <div
      *ngIf="errorMessage"
      class="w-full p-5 text-center bg-[#ffd1d1] rounded-md my-3"
    >
      <p class="text-[#fa3d3d] max-sm:text-[12px]">{{ errorMessage }}</p>
    </div>

    <form
      *ngIf="!isSuccess"
      [formGroup]="newEstateForm"
      (submit)="onSubmit()"
      class="overflow-y-scroll h-[400px] scrollbar-hide"
    >
      <div class="mb-4">
        <label class="block text-[#111] text-sm font-medium mb-1">Email</label>
        <input
          type="email"
          class="w-full border rounded px-3 py-2"
          name="email"
          formControlName="email"
          required
        />
      </div>

      <div class="mb-4">
        <label class="block text-[#111] text-sm font-medium mb-1"
          >First Name</label
        >
        <input
          type="text"
          class="w-full border rounded px-3 py-2"
          name="firstName"
          formControlName="firstName"
          required
        />
      </div>

      <div class="mb-4">
        <label class="block text-[#111] text-sm font-medium mb-1"
          >Last Name</label
        >
        <input
          type="text"
          class="w-full border rounded px-3 py-2"
          name="lastName"
          formControlName="lastName"
          required
        />
      </div>

      <div class="mb-4">
        <label class="block text-[#111] text-sm font-medium mb-1"
          >Estate Name</label
        >
        <input
          type="text"
          class="w-full border rounded px-3 py-2 text-[#111]"
          name="estateName"
          formControlName="estateName"
          required
        />
      </div>
      <div class="mb-4">
        <label class="block text-[#111] text-sm font-medium mb-1"
          >Estate Location</label
        >
        <input
          type="text"
          class="w-full border rounded px-3 py-2 text-[#111]"
          name="estateLocation"
          formControlName="estateLocation"
          required
        />
      </div>

      <div class="mb-4">
        <label class="block text-[#111] text-sm font-medium mb-1"
          >Applicant Category</label
        >
        <select
          class="w-full border rounded px-3 py-2 text-[#111]"
          name="applicantCategory"
          formControlName="applicantCategory"
          required
        >
          <option value="" disabled selected>Select a category</option>
          <option value="RESIDENT">Resident</option>
        </select>
      </div>

      <!-- <div class="mb-4">
        <label class="block text-[#111] text-sm font-medium mb-1"
          >Applicant Category</label
        >
        <input
          type="text"
          class="w-full border rounded px-3 py-2 text-[#111]"
          name="applicantCategory"
          formControlName="applicantCategory"
          required
        />
      </div> -->

      <div class="mb-4">
        <label class="block text-[#111] text-sm font-medium mb-1"
          >Phone Number</label
        >
        <input
          type="tel"
          class="w-full border rounded px-3 py-2 text-[#111]"
          name="phoneNumber"
          formControlName="phoneNumber"
          required
        />
      </div>

      <div class="flex justify-end space-x-3">
        <button
          type="button"
          (click)="showModal = false"
          class="px-4 py-2 bg-[#111] rounded hover:bg-gray-400"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="px-4 py-2 bg-[#336799] text-white rounded hover:bg-[#79abda]"
        >
          <div
            *ngIf="isLoaded"
            class="inline-flex items-center text-white text-sm font-medium rounded-md opacity-70 cursor-not-allowed"
            type="button"
            disabled
          >
            <span
              class="animate-spin inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full mr-2"
              aria-hidden="true"
            ></span>
            <span class="sr-only" role="status">Loading...</span>
          </div>

          <span *ngIf="!isLoaded">Register</span>
        </button>
      </div>
    </form>
    <div *ngIf="isSuccess">
      <div class="text-right">
        <button (click)="closeModal()" class="text-zinc-400 font-[600]">
          x
        </button>
      </div>
      <div
        class="container flex flex-col justify-center items-center text-center"
      >
        <img src="/assets/icons/success.png" alt="" />
        <h5 class="mt-2 text-[#111]">
          your estate registration request has been recieved, our team will
          contact you
        </h5>
      </div>
    </div>
  </div>
</div>
